import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "m5.79001 10.0386 1.17063-1.17062 4.66036-4.6604 1.1817 1.17062-4.6604 4.6604 4.6604 4.6604-1.1817 1.1817-4.66036-4.6715-1.17063-1.1706Z" }) });
export {
  p as LessThan
};
//# sourceMappingURL=LessThan.js.map
